( function( $ ) {

    console.log('mtm2020-custom-email-message.js ready');
    
    $( document ).ready(function() {
    });

} )( jQuery );
